import styled, { css } from 'styled-components';

const Container = styled.div<{ $noScroll?: boolean }>`
  position: relative;
  height: 100%;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.scrollBar} transparent;

  ${({ $noScroll }) =>
    !$noScroll &&
    css`
      scrollbar-gutter: stable;

      &:hover {
        overflow-y: scroll;
      }
    `}
`;

const InlineLoaderContainer = styled.div`
  position: relative;
  height: 50px;
`;

export const Styled = {
  Container,
  InlineLoaderContainer,
};
